const apis = {
	login: '/server/login', //登录
	register: "/server/register", //注册 
	getConfig: "/index/getConfig", //全局参数
	getUserList: "customer/getUserList", // 获取客户列表
	getConnectionList: 'customer/getConnectionList',//获取会话列表
	getChatLogList: 'customer/getChatLogList',//获取聊天记录列表
	getMaterialList: 'customer/getMaterialList', //获取素材列表
	getInfo: 'server/getInfo' ,//获取用户信息
	upload: 'common/upload',//上传方法
	addMaterial: 'customer/addMaterial' ,//上传文件
	delMaterial:'customer/delMaterial',//删除文件
	addWording:'customer/addWording',//添加话术库
	editWording:'customer/editWording',//编辑话术库
	delWording:'customer/delWording',//删除话术库
	getWordingList:'customer/getWordingList',//获取话术库列表
	getWordingInfo:'customer/getWordingInfo',//获取话术库详情
	getNoticeList:'richtext/getNoticeList',
	getSubscribeList:'subscribe/getSubscribeList',
	getData:"recharge/getData",
	submit:'recharge/submit',
	getChatSubscribe:'subscribe/getChatSubscribe',
	getOrderList:'subscribe/getOrderList',
	subscribe:'subscribe/submit',
	getChannelList:'channel/getChannelList',
	getTeamList:"team/getTeamList",
	addTeam:'team/addTeam',
	editTeam:'team/editTeam',
	getServerList:'options/getServerList',
	addGroup:'team/addGroup',
	groupList:'team/groupList',
	buildDiyJs:"channel/buildDiyJs",
	addChannel:"channel/addChannel",
	delChannel:"channel/delChannel",
	editChannel:"channel/editChannel",
	getChannel:"channel/getChannel",
	changeStatus:"channel/changeStatus",


	
};

export default apis;